/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'confluence.error.panel.refresh.app': '刷新应用',
  'confluence.error.panel.reload.page': '重新加载页面',
  'confluence.icon.label': '图标',
  'confluence.modal.dialog.close.modal.button': '取消',
  'confluence.select.required.field.message': '此字段为必填项。',
  'confluence.text.area.required.field.message': '此字段为必填项。',
  'confluence.textfield.validator.email': '请输入有效的电子邮件地址。',
  'confluence.textfield.validator.number': '请输入有效数字',
  'confluence.textfield.validator.required.field.message': '此字段为必填项。',
  'confluence.textfield.validator.telephone': '请输入有效的电话号码。',
  'confluence.threeLOPrompt.modal.access.required.title': '需要访问权限',
  'confluence.threeLOPrompt.modal.error.title': '错误',
  'confluence.threeLOPrompt.modal.no.authURL.error-message': '未找到许可 URL。请刷新此页面并重试。',
  'confluence.threeLOPrompt.no.authURL.error-message': '未找到许可 URL。请刷新此页面并重试。',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': '允许访问',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': '配置访问权限',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': '身份验证失败。',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    '对于要显示的 {appString}，您需要允许应用以您的名义访问 Atlassian 产品。',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message': '{appString} 需要您帐户的额外访问权限。',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': '外部身份验证警告',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': '此应用',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': '此应用',
  'confluence.user.group.unknown.user.message': '未知用户',
  'confluence.user.picker.empty.field.error.message': '此字段为必填项。',
  'confluence.user.unknown.user.message': '未知用户',
  'forge-ui.form.submit-button.text': '提交',
};
